module.exports = __webpack_public_path__ + "static/img/jiang2.a847af7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiang2.png
// module id = O6dj
// module chunks = 1